import { Divider, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import {
    Control,
    FieldErrors,
    useForm,
    UseFormRegister,
    UseFormReset,
    UseFormSetValue,
} from "react-hook-form";
import { shallowEqual, useSelector } from "react-redux";

import { compressImageFile, customValidation, EPhone, formatPhoneNumber, validations } from "../../../commonFunctions/CommonFunctions";
import WSButton from "../../../Components/Button/WSButton";
import WSImageUpload from "../../../Components/FileUpload/WSImageUpload";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
import WSPhone from "../../../Components/Phone/WSPhone";
import WSRadioField from "../../../Components/Radio/WSRadio";
import WSSelectField from "../../../Components/Select/WSSelect";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import { WSHeaderCard } from "../../../Components/View/HeaderCard";
import clientConfig from '../../../Config/clientConfig.json';
import config from '../../../Config/config.json';
import { AppState } from "../../../StateManagement/types";
interface TaskProps {
    control?: Control<any>;
    errors?: FieldErrors;
    register: UseFormRegister<any>;
    id: any;
    reset: UseFormReset<any>;
    memberId?: string;
    setValue: UseFormSetValue<any>;
    onCancel: () => void
    onSubmit: (data: any) => void
    memberdata?: any
}
const AddMemberDrawyer: React.FC<TaskProps> = ({
    memberId, onCancel, onSubmit, memberdata
}) => {

    const { showMessage } = useSnackbar();
    const { register, handleSubmit, control, setValue, reset } = useForm();
    const [imageUrl, setImageUrl] = useState<any>([]);

//   const reduxComponent = useSelector(
//         (state: AppState) => state.components["isSavedSuccess"],
//         shallowEqual
//     );

    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    useEffect(() => {
        return () => {
            reset();
           
        };
    }, []);

    useEffect(() => {
        if (memberdata) {
            for (const field in memberdata) {
                if (field === 'phoneNumber') {
                    setValue(field+'Member', formatPhoneNumber((memberdata as any)[field], EPhone.AddHyphen))
                }
                else if (field === 'profileImageUrl' && memberdata?.profileImageUrl!==null) {
                    setImageUrl(`${config.imgUrl}${memberdata[field].replace("UploadedImages/", "")}`)
                }
                else {
                    setValue(field+'Member', (memberdata as any)[field]);
                }
            }
        }
    }, [memberdata])
   


    const reduxComponentData = useSelector(
        (state: AppState) => state.components["memberSubmit"],
        shallowEqual
    );

  


    // Local state to store Redux data
    const [componentData, setComponentData] = useState(reduxComponentData);
    // useEffect(() => {
    //     if (reduxComponent) {
    //         if (reduxComponent?.data?.isSaved == true) {
    //             reset()
    //             setSelectedFile(null)
    //         }
    //     }
    // }, [reduxComponent]);
    // Update useState when Redux state changes
    useEffect(() => {
        if (reduxComponentData) {
            setComponentData(reduxComponentData);
        }
    }, [reduxComponentData]);
    const handleUploadChange = async (uploadedFile: any) => {
        try {
            let newFile: any = await compressImageFile(uploadedFile);
            setSelectedFile(newFile)
        } catch (error) {
            showMessage("Error converting file to base64:", 'error');
        }
    }
    const handleMemeberData = async (data: any) => {
        onSubmit(data)
    }
     const resetMemberData = () => {
        setValue("profileImageMember", null);
        setValue("phoneNumberMember", "");
        setValue("customerNameMember", "");
        setValue("emailMember", "");
        setValue("ageMember", "");
        setValue("bloodGroupMember", "");
        setValue("genderMember", 'Male');
        setValue("addressLine1Member", "");
        setValue("addressLine2Member", "");
        setValue("stateMember", "");
        setValue("cityMember", "");
        setValue("pincodeMember", "");
        setValue("weightMember", "");
        setValue("heightMember", "");
    }
    return (
        <Grid >
            {<form onSubmit={handleSubmit(handleMemeberData)}>
                <Grid xs={12} container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item sm={12} xs={12}>
                        <WSHeaderCard header="Profile" backGroundColor="#DDF2EBCC" />
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item>
                                <WSImageUpload
                                    control={control}
                                    id="profileImageMember"
                                    name="profileImageMember"
                                    label="Profile Image"
                                    rules={{ required: false }}
                                    onChange={handleUploadChange}
                                    imgUrl={imageUrl}
                                />
                            </Grid>

                        </Grid>

                    </Grid>

                    <Grid item sm={12} xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <WSHeaderCard header="Basic Information" backGroundColor="#DDF2EBCC" />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="customerNameMember" name="customerNameMember" rules={{ required: false }} label="Name*"></WSTextField>

                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="emailMember" {...register('emailMember')} name="emailMember" rules={customValidation(true, validations.email)} label="Email *"></WSTextField>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSPhone label="Phone" rules={{ required: false }} control={control} id="phoneNumberMember" {...register('phoneNumberMember')} name="phoneNumberMember" ></WSPhone>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField maxLength={2} control={control} type={TextType.AllowOnlyNumber} id="ageMember" name="ageMember" rules={{ required: false }} label="Age *"></WSTextField>

                    </Grid>

                    <Grid item sm={6} xs={12}>
                        <WSRadioField defaultValue={'Male'} control={control} label="Gender" rules={{ required: false }} id="genderMember" name="genderMember" options={clientConfig.genderConfig.staticOptionData}></WSRadioField>
                    </Grid>


                    <Grid item sm={12} xs={12}>
                        <WSHeaderCard header="Address Information" backGroundColor="#DDF2EBCC" />

                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="addressLine1Member" name="addressLine1Member" rules={{ required: false }} label="Address Line1 *"></WSTextField>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="addressLine2Member" name="addressLine2Member" rules={{ required: false }} label="Address Line2 "></WSTextField>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="stateMember" name="stateMember" rules={{ required: false }} label="State *"></WSTextField>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="cityMember" name="cityMember" rules={{ required: false }} label="City *"></WSTextField>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="pincodeMember" name="pincodeMember" rules={{ required: false }} label="Pincode *" maxLength={6}></WSTextField>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <WSHeaderCard header="Additional Information" backGroundColor="#DDF2EBCC" />

                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField maxLength={2} control={control} type={TextType.Number} id="heightMember" name="heightMember" rules={{ required: false }} label="Height"></WSTextField>

                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField maxLength={2} control={control} type={TextType.Number} id="weightMember" name="weightMember" rules={{ required: false }} label="Weight"></WSTextField>
                        <WSHiddenField control={control} name="memberId" defaultValue={memberId} />
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            rules={{ required: false }}
                            id="bloodGroupMember"
                            control={control}
                            options={clientConfig.bloodGroup.staticOptionData}
                            label="Blood Group"
                            name="bloodGroupMember"
                        />
                    </Grid>
                    {/* 
                        <Grid item sm={12} xs={12}>
                            <WSHeaderCard header="About" backGroundColor="#DDF2EBCC" />

                        </Grid> */}
                    <Grid item xs={12} sm={12}>
                        <Divider />
                    </Grid>
                    <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton className="ws-theme-crm" variant="outlined" id='memberSubmit' label={"Save"} type="submit" size="medium" loading={reduxComponentData?.data?.loading} />
                        </Grid>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton id='cancel' label={"Cancel"} onClick={()=>{onCancel();resetMemberData()}} type="button" size="medium" variant="outlined" className="ws-theme-crm" />
                        </Grid>
                    </Grid>
                </Grid>

            </form>
            }
        </Grid >
    );
};
export default AddMemberDrawyer;
